var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9958 6.99576C13.9974 7.20085 13.935 7.40133 13.8174 7.56935C13.6998 7.73736 13.5328 7.86456 13.3395 7.93326L9.37451 9.37514L7.93326 13.3395C7.86223 13.5309 7.73432 13.6959 7.56674 13.8125C7.39915 13.9291 7.1999 13.9915 6.99576 13.9915C6.79163 13.9915 6.59238 13.9291 6.42479 13.8125C6.25721 13.6959 6.1293 13.5309 6.05826 13.3395L4.61701 9.37451L0.652015 7.93326C0.460638 7.86223 0.295585 7.73432 0.179029 7.56674C0.0624741 7.39915 0 7.1999 0 6.99576C0 6.79163 0.0624741 6.59238 0.179029 6.42479C0.295585 6.25721 0.460638 6.1293 0.652015 6.05826L4.61701 4.61701L6.05826 0.652015C6.1293 0.460638 6.25721 0.295585 6.42479 0.179029C6.59238 0.0624741 6.79163 0 6.99576 0C7.1999 0 7.39915 0.0624741 7.56674 0.179029C7.73432 0.295585 7.86223 0.460638 7.93326 0.652015L9.37514 4.61701L13.3395 6.05826C13.5328 6.12697 13.6998 6.25417 13.8174 6.42218C13.935 6.5902 13.9974 6.79068 13.9958 6.99576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.eebbfe16ad09e31acf0e16d62f00350e.svg";
export { ForwardRef as ReactComponent };